<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"><a id="ch00_fm01"></a><a id="page_tpb1"></a>After leaving school at fifteen, <strong>Mo Hayder</strong> worked as a barmaid, security guard, film-maker, hostess in a Tokyo club, educational administrator and teacher of English as a foreign language in Asia. She has an MA in creative writing from Bath Spa University, where she now teaches.</p>
<p class="noindent2a">She is the author of <em>Birdman, The Treatment</em>, which won the 2001 WH Smith Thumping Good Read Award, and <em>Tokyo</em>, which was shortlisted for the CWA Gold and Steel Dagger Awards for Novels of the Year, 2004. They are published in paperback by Bantam Books.</p>
<hr/>
<p class="textcenterw"><span class="weblink"><a class="nounder" href="http://www.booksattransworld.co.uk" target="_blank">www.booksattransworld.co.uk</a></span></p>
<hr/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01.vue?cdc00718